import PropTypes from 'prop-types'

const KubernetesGraph = ({ selection, ...rest }) => {
  const isDeployment1Selected = selection.includes('Deployment-1')
  const isDeployment2Selected = selection.includes('Deployment-2')
  const isStatefulSet1Selected = selection.includes('StatefulSet-1')
  const isDaemonSet1Selected = selection.includes('DaemonSet-1')
  const isDaemonSet2Selected = selection.includes('DaemonSet-2')

  return (
    <svg viewBox="0 0 240 240" {...rest}>
      <g fill="none" fillRule="evenodd">
        <rect
          fill="#FFF"
          stroke="#979797"
          strokeOpacity="0.5"
          strokeWidth="0.5"
          width={240}
          height={240}
          rx={120}
        />
        <g
          transform="translate(67 5)"
          stroke="#979797"
          strokeOpacity="0.5"
          strokeWidth="0.5"
          id="StatefulSet-1"
        >
          <rect
            id="StatefulSet-1-background"
            fill={isStatefulSet1Selected ? '#407DE0' : '#F2F2F2'}
            width={67}
            height={67}
            rx={33.5}
          />
          <path
            d="M49.5 18C57.508 18 64 24.492 64 32.5v1C64 41.508 57.508 48 49.5 48S35 41.508 35 33.5v-1C35 24.492 41.492 18 49.5 18zm-32 0C25.508 18 32 24.492 32 32.5v1C32 41.508 25.508 48 17.5 48S3 41.508 3 33.5v-1C3 24.492 9.492 18 17.5 18z"
            fill={isStatefulSet1Selected ? '#ADF37B' : '#FFF'}
          />
        </g>
        <g
          id="Deployment-2"
          transform="translate(107 85)"
          stroke="#979797"
          strokeOpacity="0.5"
          strokeWidth="0.5"
        >
          <rect
            id="Deployment-2-background"
            fill={isDeployment2Selected ? '#6E40AA' : '#F2F2F2'}
            width={123}
            height={124}
            rx={61.5}
          />
          <path
            id="Deployment-2-pods"
            d="M75.5 18C83.508 18 90 24.492 90 32.5v1C90 41.508 83.508 48 75.5 48S61 41.508 61 33.5v-1C61 24.492 67.492 18 75.5 18zm-30 0C53.508 18 60 24.492 60 32.5v1C60 41.508 53.508 48 45.5 48S31 41.508 31 33.5v-1C31 24.492 37.492 18 45.5 18zm31 56C84.508 74 91 80.492 91 88.5v1c0 8.008-6.492 14.5-14.5 14.5S62 97.508 62 89.5v-1C62 80.492 68.492 74 76.5 74zm-30 0C54.508 74 61 80.492 61 88.5v1c0 8.008-6.492 14.5-14.5 14.5S32 97.508 32 89.5v-1C32 80.492 38.492 74 46.5 74zm15-28C69.508 46 76 52.492 76 60.5v1C76 69.508 69.508 76 61.5 76S47 69.508 47 61.5v-1C47 52.492 53.492 46 61.5 46zm-31 0C38.508 46 45 52.492 45 60.5v1C45 69.508 38.508 76 30.5 76S16 69.508 16 61.5v-1C16 52.492 22.492 46 30.5 46zm62 0c8.008 0 14.5 6.492 14.5 14.5v1c0 8.008-6.492 14.5-14.5 14.5S78 69.508 78 61.5v-1C78 52.492 84.492 46 92.5 46z"
            fill={isDeployment2Selected ? '#ADF37B' : '#FFF'}
          />
        </g>
        <g
          id="DaemonSet-2"
          transform="translate(135 17)"
          stroke="#979797"
          strokeOpacity="0.5"
          strokeWidth="0.5"
        >
          <rect
            id="DaemonSet-2-background"
            fill={isDaemonSet2Selected ? '#1AC7C2' : '#F2F2F2'}
            width={67}
            height={67}
            rx={33.5}
          />
          <rect
            id="DaemonSet-2-pods"
            fill={isDaemonSet2Selected ? '#ADF37B' : '#FFF'}
            x={19}
            y={18}
            width={29}
            height={30}
            rx={14.5}
          />
        </g>
        <g
          id="DaemonSet-1"
          transform="translate(51 163)"
          stroke="#979797"
          strokeOpacity="0.5"
          strokeWidth="0.5"
        >
          <rect
            id="DaemonSet-1-background"
            fill={isDaemonSet1Selected ? '#1AC7C2' : '#F2F2F2'}
            width={67}
            height={67}
            rx={33.5}
          />
          <rect
            id="DaemonSet-1-pods"
            fill={isDaemonSet1Selected ? '#ADF37B' : '#FFF'}
            x={19}
            y={19}
            width={29}
            height={30}
            rx={14.5}
          />
        </g>
        <g
          id="Deployment-1"
          transform="translate(2 62)"
          stroke="#979797"
          strokeOpacity="0.5"
          strokeWidth="0.5"
        >
          <rect
            id="Deployment-1-background"
            fill={isDeployment1Selected ? '#6E40AA' : '#F2F2F2'}
            width={106}
            height={104}
            rx={52}
          />
          <rect
            id="Deployment-1-replicaset"
            fill={isDeployment1Selected ? '#23C386' : '#F2F2F2'}
            x={19}
            y={18}
            width={68}
            height={67}
            rx={33.5}
          />
          <rect
            id="Deployment-1-pods"
            fill={isDeployment1Selected ? '#ADF37B' : '#FFF'}
            x={39}
            y={37}
            width={29}
            height={30}
            rx={14.5}
          />
        </g>
      </g>
    </svg>
  )
}

KubernetesGraph.propTypes = {
  selection: PropTypes.array.isRequired,
}

export default KubernetesGraph
